<!-- <mat-form-field class="{{ style }}"> </mat-form-field> -->

<div
	class="select-container {{ style }} {{className}}"
	(click)="onToggle()"
>
	<h3 class="value text-truncate">
		{{ label }}
	</h3>
	<span class="spacer"></span>
	<mat-icon class="chev-icon" svgIcon="chev-down"></mat-icon>
	<div
		class="options-container"
		[class.open]="showOptions"
	>
		<div
			class="option"
			*ngFor="let item of values"
			(click)="onValueSelection(item)"
		>
			<p [style.maxWidth.px]="contentWidth" class="text-truncate">
				{{ item.label }}
			</p>
		</div>
	</div>
</div>
